import { Component, Inject, Input, OnChanges } from '@angular/core';
import { Moment } from 'moment';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { DateRangeFilter } from '@models/filter-types';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { segmentTrack } from '@shared/helpers/functions/helpers';
import { Router } from '@angular/router';
import { MyDateAdapter } from '../date-select/date-select.component';
import { FilterInputErrorStateMatcher } from '@shared/components/filters/filter-input-error-state-matcher';

const US_LOCALE = 'en-US';
const dateRangeFormats = (): MatDateFormats => ({
    parse: { ...MAT_MOMENT_DATE_FORMATS.parse },
    display: { ...MAT_MOMENT_DATE_FORMATS.display },
});

@Component({
    selector: 'app-date-range-select',
    templateUrl: './date-range-select.component.html',
    styleUrls: ['./date-range-select.component.scss'],
    providers: [
        { provide: MAT_DATE_FORMATS, useFactory: dateRangeFormats },
        { provide: MAT_DATE_LOCALE, useValue: US_LOCALE },
        { provide: DateAdapter, useClass: MyDateAdapter, deps: [MAT_DATE_LOCALE] },
    ],
    standalone: false,
})
export class DateRangeSelectComponent implements OnChanges {
    @Input() startDate!: Moment;
    @Input() endDate!: Moment;

    @Input() icon!: string;
    @Input() disabled = true;
    @Input() property!: DateRangeFilter;
    @Input() appearance?: 'outline' | 'fill';
    @Input() showErrorsAfterInteraction = false;
    @Input() compactDisplay = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errorStateMatcher: FilterInputErrorStateMatcher<any>;

    constructor(
        private router: Router,
        @Inject(MAT_DATE_FORMATS) private dateFormats: MatDateFormats,
    ) {}

    ngOnChanges(): void {
        this.dateFormats.display.dateInput = this.compactDisplay ? 'M/D/YY' : MAT_MOMENT_DATE_FORMATS.display.dateInput;
        this.errorStateMatcher = new FilterInputErrorStateMatcher(this.property, this.showErrorsAfterInteraction);
    }

    startDateChanged(value: MatDatepickerInputEvent<Moment>) {
        this.property.Value = { startDate: value.value, endDate: this.property.Value?.endDate };
    }

    endDateChanged(value: MatDatepickerInputEvent<Moment>) {
        this.property.Value = { startDate: this.property.Value?.startDate, endDate: value.value };
    }

    closed(): void {
        segmentTrack('User Selected From Dropdown', {
            dropdown: this.property.Key,
            selection: this.property.transform(this.property.Value),
            screen: this.router.url,
        });
    }
}
